theme.SailthruObj = {
    "lists" : {
        "TRTL_Master_List_ES" : 1, // list to add user to (must exist in Sailthru account)
        "Anonymous" : 0 // list to remove user from (must exist in Sailthru account)
    },
    "vars" : {
        "sign_up_date" : "today"
        }
    }